export default __webpack_public_path__ + "static/media/kingston.0ed7f2b3.svg";